<section *ngIf="alerts.length" class="alerts-tasks">
  <button
    *ngIf="hasMultipleAlerts"
    type="button"
    class="alerts-toggle"
    data-test-id="alerts-toggle"
    [attr.aria-expanded]="isExpanded"
    aria-controls="alerts-tasks-list"
    (click)="toggleAlerts()"
  >
    <span class="alerts-toggle-inner">
      <span class="alerts-toggle-label">
        <mat-icon
          svgIcon="leaf-system-filled-info"
          aria-hidden="true"
        ></mat-icon>
        <ng-leaf-heading type="title-small" [brandColor]="true">
          You have {{ alerts.length }} alerts
        </ng-leaf-heading>
      </span>
      <cigna-icon
        [type]="isExpanded ? 'chevron-thin-up' : 'chevron-thin-down'"
        aria-hidden="true"
      ></cigna-icon>
    </span>
  </button>

  <div id="alerts-tasks-list" class="alerts-list">
    <ng-leaf-alert
      *ngFor="let alert of visibleAlerts"
      [attr.data-alert-id]="alert.alertId"
      [headerText]="
        getCopyKey(alert, 'heading') | translate : getCopyParams(alert)
      "
      [status]="getStatus(alert)"
      [emphasis]="getEmphasis(alert)"
      [notDismissible]="true"
      variant="banner"
    >
      {{ getCopyKey(alert, 'body') | translate : getCopyParams(alert) }}

      <div class="cg-margin-top-md">
        <ng-leaf-button
          [href]="'/app/my-practice/directory/update/' + alert.tin"
          size="sm"
          variant="secondary"
          [neutral]="true"
          [inverse]="getEmphasis(alert) === 'strong'"
          [text]="
            getCopyKey(alert, 'ctaText') | translate : getCopyParams(alert)
          "
        >
        </ng-leaf-button>
      </div>
    </ng-leaf-alert>
  </div>
</section>
